import { render, staticRenderFns } from "./CabecalhoGenerico.vue?vue&type=template&id=8798010e&"
import script from "./CabecalhoGenerico.vue?vue&type=script&lang=js&"
export * from "./CabecalhoGenerico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports